// extracted by mini-css-extract-plugin
export default {"imgContainer":"ClientRow_imgContainer__zkrab","nameContainer":"ClientRow_nameContainer__pN9WK","Contact":"ClientRow_Contact__w3aaB"};